import styled from 'styled-components';

export const Root = styled.button`
  margin: 0;
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  display: block;
`;
